module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Lauwil-a16cbe7792596785bc8ac29df0e3710c.svg";